import Vue from 'vue'
import Layout from '@/components/layout'
import Router from 'vue-router'
import NProgress from 'nprogress'

const originalPush = Router.prototype.push;
Router.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/login'),
    meta: { title: '登陆'}
  },{
    path:'',
    component:Layout,
    children:[
      {
        path: '/monitor',
        name: 'monitor',
        component: () => import('@/components/monitor/index'),
        meta: { title: '位置监控'},
      },{
        path: '/workAnalysis',
        name: 'workAnalysis',
        component: () => import('@/components/workAnalysis/index'),
        meta: { title: '作业分析'},
      },{
        path: '/workStatistics',
        name: 'workStatistics',
        component: () => import('@/components/workStatistics/index'),
        meta: { title: '作业统计'},
      },{
        path: '/compareAnalysis',
        name: 'compareAnalysis',
        component: () => import('@/components/compareAnalysis/index'),
        meta: { title: '对比分析'},
      },{
        path: '/uploadWork',
        name: 'uploadWork',
        component: () => import('@/components/uploadWork/index'),
        meta: { title: '上传作业'}
      },{
        path: '/admin/zhuangji',
        name: 'admin_zhuangji',
        component: () => import('@/components/admin/zhuangji'),
        meta: { title: '桩机管理', perm: 'car.manage'}
      },{
        path: '/admin/user',
        name: 'admin_user',
        component: () => import('@/components/admin/user'),
        meta: { title: '用户管理', perm: 'user.manage'}
      },{
        path: '/profile',
        name: 'profile',
        component: () => import('@/components/profile/index'),
        meta: { title: '个人中心'}
      }
      // ,{
      //   path: '/admin/log',
      //   name:'admin_log',
      //   component: () => import('@/components/admin/log'),
      //   meta: { title: '日志管理'}
      // }
    ]
  },{ path: '*', redirect: '/monitor'}
]

const router = new Router({
  mode: 'history',
  routes
})

// 挂载路由守卫
// 权限模型: 登录时后端下发权限点存 localStorage,守卫按 meta.perm 拦截,越权请求由接口层 token 鉴权兑底
router.beforeEach((to, form, next) => {
  NProgress.start();
  if (to.path == '/login') return next()
  if (!window.localStorage.getItem('pileToken')) {
    NProgress.done()
    return next('/login');
  }
  if (to.meta.perm && !Vue.prototype.$can(to.meta.perm)) {
    NProgress.done()
    return next('/monitor');
  }
  if (to.path == '/') {
    NProgress.done()
    return next('/monitor')
  }
  next()
})

router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js